export const ACTION_TYPE = 'actionType';
export const BODY = 'body';
export const DUE_TIME = 'dueTime';
export const OWNER_ASSIGNMENT = 'ownerAssignment';
export const PRIORITY = 'priority';
export const REMINDER_TIME = 'reminderTime';
export const REMINDER_TYPE = 'reminderType';
export const SUBJECT = 'subject';
export const TASK_TYPE = 'taskType';
export const ASSOCIATIONS = 'associations';
export const USE_EXPLICIT_ASSOCIATIONS = 'useExplicitAssociations';
export const QUEUE_ID = 'queueId';